import React from "react";
import {getObjectUseCase, upsertUseCase} from '../../../usecases/object';
import withRouter from "../../../withRouter";
import BaseFormPage from "../../../base/BaseFormPage";
import NavBar from "../../../components/navbar";
import InquiriesInfoPresenter from "./InquiriesInfoPresenter";
import calculateQuotation from "../../../calculateQuotation";
import { restUseCase } from "../../../usecases/rest";
import InquiryPrint from "../components/InquiryPrint";

class InquiriesInfoPage extends BaseFormPage {
    constructor(props) {
        super(props);
        this.state = {object: {}, advanced: false};
        this.presenter = new InquiriesInfoPresenter(this, getObjectUseCase(), upsertUseCase());
    }

    onClickAdvance() {
        this.setState({advanced: !this.state.advanced});
    }

    onClickSend() {
        const object = this.state.object;
        console.log("ss", object);
        const client = object.client
        const method = "POST"
        const path = "/send-email/a66266bc-0ea4-463d-b298-4c827b9cc829"

        if (!client || !client.email_address) {
            this.showError("Client email address not found")
            return
        }
      
        this.showDialog({
          icon: "bi bi-send-fill",
          title: 'Send Quotation',
          positiveButton: 'Confirm',
          negativeButton: "Cancel",
          type: "primary",
          message: 'Are you sure you want to send this quotation?',
        })
        .then(async () => {
            const emailBody = `
                <html>
                    <body style="font-family: Arial, sans-serif; color #000;">
                        <p>Good day Sir/Ma'am,</p>

                        <p>This is <strong>EBOWR</strong>. You have been sent a quotaation request through our system.</p>
                        <p>Please click the link below to view the quotation:</p>

                        ${object.link}

                        <p>If you have any questions or concerns regarding this quotation, kindly contact the seller you previously contacted with.</p>

                        <p>Thank you for using EBOWR and have a great day!</p>

                        <strong>Please note:</strong>
                        <p>This is a <strong>system-generated message. No need to reply</strong> to this email.</p>
                    </body>
                </html>
            `

            const emailSend = {
                to: client.email_address,
                subject: "Your Quotation",
                body: emailBody
            }

            try {
                await restUseCase().execute(method, path, { body: emailSend })

                const updatedInquiry = {
                    id: object.id,
                    status: 'Pending (Warm Lead)'
                }
                await upsertUseCase().execute(this.getCollectionName(), updatedInquiry)

                this.showSuccess('Quotation sent!')
                this.setState(prevState => ({
                    object: {
                        ...prevState.object,
                        status: 'Pending (Warm Lead)'
                    }
                }))
            } catch (error) {
                console.error('Failed to send quotation', error)
                this.showError('Failed to send quotation.')
            }
        })
        .catch((error) => {
            if (error) {
                console.error("User cancelled or error occured", error)
            }
        })
      }                 

    render() {
        const object = this.state.object;
        const schema = this.getSchema(this.getCollectionName());
        if (!schema) return <h1>no schema</h1>;
        const {
            parseNum,
            formatNum,
            grossFloorArea,
            netOfUnitTypeDiscount,
            launchDiscountValue,
            equityValue,
            monthlyAmortization,
            retentionValue,
            closingFeeValue
        } = calculateQuotation(object)
        
        return (
            <>
                <NavBar
                    action={() => (
                        <div className="dropdown dropstart d-inline-block">
                            <i role="button" data-bs-toggle="dropdown" className="bi bi-three-dots-vertical"></i>
                            <div className="dropdown-menu fs-xs">
                                <button
                                    onClick={this.onClickAdvance.bind(this)}
                                    className="dropdown-item py-3">
                                    <i className='bi bi-gear pe-2'/>Toggle Advance
                                </button>
                            </div>
                        </div>
                    )}/>
                <div className="overflow-auto">
                    <div className="h-100">
                        <div className="p-3 p-lg-4">
                            <div className="d-flex align-items-start mt-3">
                            <i className="bi bi-chevron-left" style={{ fontSize: '1.5rem' }} onClick={this.onClickBack.bind(this)}></i>
                            <h1 className="fw-bold text-capitalize"> Quotation</h1>
                            </div>
                            <div className="mt-3 bg-white border border-gray rounded p-3 px-lg-5 py-lg-4">
                                <div className="d-flex justify-content-between">
                                    <div className="d-flex">
                                        {object.second_logo && (
                                        <div>
                                            <img 
                                                src={object.second_logo}
                                                alt="Second logo"
                                                style={{ maxWidth: "50px", maxHeight: "50px" }}/>
                                        </div>
                                        )}
                                    </div>
                                    <div className="d-flex">
                                        {object.logo && (
                                        <div>
                                            <img 
                                                src={object.logo}
                                                alt="First logo"
                                                style={{ maxWidth: "50px", maxHeight: "50px" }}/>
                                        </div>
                                        )}
                                    </div>
                                </div>
                                <div className="d-flex justify-content-center mt-3 overflow-x-auto">
                                    <table className="min-w-full table-fixed text-center border border-gray-900 text-black">
                                    <tbody>
                                    {[
                                        { label: 'Payment Term', value: object.payment_term },
                                        { label: 'Unit Type', value: object.unit_type },
                                        { label: 'Unit', value: object.unit },
                                        { label: 'Unit View', value: object.unit_view },
                                        { label: 'Floor Area (SQM)', value: formatNum(object.floor_area) },
                                        { label: 'Balcony (SQM)', value: formatNum(object.balcony) },
                                        { label: 'Gross Floor Area', value: formatNum(grossFloorArea) },
                                        { label: 'Gross Unit Price', value: formatNum(object.gross_unit_price) },
                                        { label: 'Unit Type Discount', value: formatNum(object.unit_type_discount) }, 
                                        { label: 'Net of Unit Type Discount', value: formatNum(netOfUnitTypeDiscount) },
                                        { label: 'Launch Discount', value: formatNum(launchDiscountValue) },
                                        { label: 'Equity', value: formatNum(equityValue) },
                                        { label: 'Reservation Fee', value: parseNum(object.reservation_fee) },
                                        { label: 'Monthly Amortization', value: formatNum(monthlyAmortization) },
                                        { label: 'Retention', value: formatNum(retentionValue) },
                                        { label: 'Closing Fee', value: formatNum(closingFeeValue) }
                                        ].map((item, index) => (
                                        <tr key={index}>
                                            <td className={`${item.label === 'Payment Term' ? '' : 'bg-primary border border-gray-900'} px-4 fs-sm fw-bold`}>
                                            {item.label}
                                            </td>
                                            <td className={`${item.label === 'Payment Term' ? 'p-2 fs-sm' : 'p-2 fs-sm border border-gray-900'}`}>
                                            {item.value || '-'}
                                            </td>
                                        </tr>
                                    ))}
                                    </tbody>
                                    </table>
                                </div>
                                <div className="mt-4 d-flex justify-content-center">
                                    <button type="button" className="btn btn-light fs-sm w-50 me-3 fw-bolder"
                                            onClick={this.onClickBack.bind(this)}>Cancel
                                    </button>
                                    <button type="button" className="btn btn-primary w-50 fs-sm fw-bolder text-black" onClick={this.onClickSend.bind(this)}>
                                            Send
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </>
        )
    }
}

export default withRouter(InquiriesInfoPage);
